var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M22.544 3.044L7 18.585l-5.544-5.541-1.413 1.413 6.25 6.25a.999.999 0 001.412 0l16.25-16.25-1.413-1.413z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }